var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import createElement from '../logical-components/createElement';
import rememberMeVisualComponent from '../visual-components/rememberMe';
import handleErrorUtil from '../core/utils/handleError';
import getIdFromLocation from "../core/utils/getIdFromLocation";
// API
import api from '../core/utils/api';
// Global helpers
import svgs from '../visual-components/svgs';
import renderText from '../logical-components/renderText';
import internalEvents from '../logical-components/internalEvents';
import widgetStyleDetection from '../logical-components/widgetStyleDetection';
// section Helpers
import generateMeta from '../visual-components/card-meta';
import generateCondolences from '../logical-components/rememberMe-condolences';
import generateServices from '../visual-components/rememberMe-services';
import rememberMeActionWrapper from '../visual-components/rememberMe-actions';
import generateGallery from '../visual-components/rememberMe-gallery';
import generateAdvertisements from '../visual-components/rememberMe-advertisements';
// import { condolences as condolencesMock, rememberMe as rememberMeMock } from '../../_mocks_/rememberMeMock'
// import serviesMock from '../../_mocks_/services'
// Simple section for the powered by footer
var rememberMe = function (_a) {
    var _b;
    var config = _a.config, section = _a.section, data = _a.data;
    var dataToUse = data;
    var hasData = !!dataToUse;
    var services = [];
    var condolencesState = { data: [], meta: {} };
    // get latest id from url
    var personId = getIdFromLocation(window.location) || ((_b = section === null || section === void 0 ? void 0 : section.options) === null || _b === void 0 ? void 0 : _b.defaultId);
    var wrapper = createElement('div', [
        { type: 'class', value: '_mnslq-rememberMewrapper' },
    ]);
    if (!personId && !hasData) {
        handleErrorUtil({
            section: 'rememberMe',
            message: "person ID not defined",
        });
        return wrapper;
    }
    var onSubmit = function (data) {
        // post
        console.log(data);
        var updatedPayload = __assign(__assign(__assign({ type: data.type === 'write' ? 'condolence' : data.type, name: data.name, email: data.email }, (data.type === 'write' ? { private: !!data.private } : {})), (data.message ? { message: data.message } : {})), (data.videoUrl ? { youtube_url: data.videoUrl } : {}));
        return api.post("/person/".concat(personId, "/interaction"), updatedPayload, {
            'X-Widget-Id': config._id,
            'X-Widget-Instance-Id': config._widgetInstanceId,
            'X-Customer-Id': config._customerId,
        });
    };
    var render = function (updatedData, updatedServices, updatedCondolences) {
        var _a, _b;
        // Refresh DOM state
        wrapper.innerHTML = '';
        // Loading state
        if (!updatedData) {
            wrapper.innerHTML = "<div class=\"_mnslq-loader-wrapper\">\n                <span class=\"_mnslq-loader\"></span>\n            </div>";
            return;
        }
        // Setup events for views callback
        var events = internalEvents(config);
        if ((_a = section === null || section === void 0 ? void 0 : section.views) === null || _a === void 0 ? void 0 : _a.section) {
            var ele = (_b = section === null || section === void 0 ? void 0 : section.views) === null || _b === void 0 ? void 0 : _b.section({
                config: config,
                section: section,
                data: updatedData,
                services: updatedServices,
                svgs: svgs,
                renderText: renderText,
                events: events,
                generatedMeta: generateMeta(config, section, {
                    meta: {
                        writes: (data === null || data === void 0 ? void 0 : data.condolence_count) || 0,
                        candles: (data === null || data === void 0 ? void 0 : data.candle_count) || 0,
                        flowers: (data === null || data === void 0 ? void 0 : data.flower_count) || 0,
                    },
                }),
                generatedCondolences: generateCondolences(config, section, updatedCondolences, updatedData.id),
                generatedServices: generateServices(config, section, services),
                generatedActions: rememberMeActionWrapper(config, section, onSubmit),
                generatedGallery: generateGallery(config, section, dataToUse.gallery),
                generatedAdvertisements: generateAdvertisements(config, section, dataToUse.advertisements),
            });
            if (typeof ele === 'string') {
                wrapper.innerHTML = ele;
            }
            else {
                wrapper.appendChild(ele);
            }
        }
        else {
            wrapper.appendChild(rememberMeVisualComponent({
                config: config,
                section: section,
                data: updatedData,
                services: updatedServices,
                condolences: updatedCondolences,
                onSubmit: onSubmit,
            }));
        }
        // When we rerender, we need to recalc the style to use
        widgetStyleDetection(wrapper.querySelector('._mnslq-rememberMe-element'), config);
    };
    // initial render
    render(dataToUse, services, condolencesState);
    // Async data requests
    var getCondolences = function () {
        api("/person/".concat(personId || data.id, "/interaction?page=1"), [], {
            'X-Widget-Id': config._id,
            'X-Widget-Instance-Id': config._widgetInstanceId,
            'X-Customer-Id': config._customerId,
            'X-Uri': window.location.href,
        })
            .then(function (data) {
            condolencesState = data;
            render(dataToUse, services, condolencesState);
        });
    };
    if (!hasData) {
        api("/person/".concat(personId || data.id), [], {
            'X-Widget-Id': config._id,
            'X-Widget-Instance-Id': config._widgetInstanceId,
            'X-Customer-Id': config._customerId,
            'X-Uri': window.location.href,
        })
            .then(function (data) {
            dataToUse = data;
            hasData = true;
            render(dataToUse, services, condolencesState);
            if (condolencesState.data.length === 0) {
                getCondolences();
            }
        });
    }
    else {
        if (condolencesState.data.length === 0) {
            getCondolences();
        }
    }
    return wrapper;
};
export default rememberMe;
